const SESSION_EXPIRED_ERROR_CODES = [
  "login_required",
  "missing_refresh_token",
  "invalid_grant",
];

const isAuth0Error = (err: unknown): err is { error: string } =>
  typeof err === "object" && err !== null && "error" in err;

export const isSessionExpiredError = (err: unknown): boolean =>
  isAuth0Error(err) && SESSION_EXPIRED_ERROR_CODES.includes(err.error);

// auth0-spa-js rejects fetch timeouts with a plain Error, not its TimeoutError class
const AUTH0_FETCH_TIMEOUT_MESSAGE = "Timeout when executing 'fetch'";

export const isAuthTimeoutError = (err: unknown): boolean =>
  (err instanceof Error && err.message === AUTH0_FETCH_TIMEOUT_MESSAGE) ||
  (isAuth0Error(err) && err.error === "timeout");
